import { registryComponent } from '@boost-sd/components-registry/registry';
import { InnerHTMLRenderer } from '@components/InnerHTMLRenderer';

export type IntegrationProductReviewFeraProps = {
  template?: string;
};

const IntegrationProductReviewFera = ({ template }: IntegrationProductReviewFeraProps) => {
  if (!template) return null;

  return <InnerHTMLRenderer html={template} />;
};

export default registryComponent('IntegrationProductReviewFera', IntegrationProductReviewFera);
